import gql from 'graphql-tag';

export default gql`
  mutation cartDeleteItemLight($input: CartDeleteItemInput!) {
    cartDeleteItemLight(input: $input) {
      success
      userErrors {
        field
        message
      }
      cart {
        id
        buyer {
          id
        }
        store {
          id
          freeShipping
          moq
        }
        total
        carts {
          items {
            item {
              id
              note
              vat
              price
              name
              uom
            }
            total
            orderedQty
          }
          supplier {
            id
            name
            moq
          }
          total
        }
      }
    }
  }
`;
